import { StyledPhotoEditorEmojiButtons, StyledPhotoEditorPhotoStickersContainer } from 'components/Selfiebooth/PhotoEditor/styled'
import React from 'react'

interface StickersProps {
	stickers: string[];
	addStickers: (sticker: string) => void;
}

const Stickers = ({ stickers, addStickers }: StickersProps) => {

	const handleAddSticker = (src: string) => {
		addStickers(src)
	}

	return <>
		<StyledPhotoEditorPhotoStickersContainer>
			{stickers.map((sticker, index) => (
				sticker !== '' &&
				<StyledPhotoEditorEmojiButtons onClick={() => handleAddSticker(sticker)} key={`sticker-${index}`}>
					<img src={sticker} alt={`sticker-${index}`} draggable="true" />
				</StyledPhotoEditorEmojiButtons>
			))}
		</StyledPhotoEditorPhotoStickersContainer>
	</>;
};

export default Stickers;